import { Fragment } from "react";
import styled from "styled-components";
import { CustomButton } from "../../../core/components/buttons/CustomButton";
import {
  getCurrentPracticeId,
  getPracticeLogoUrlById,
} from "../../../core/store/chainSlice";
import { getIsReleaseSession } from "../../../core/store/currentFormSlice";
import { useMainStore } from "../../../core/store/mainStore";
import { useHandleParamNavigation } from "../../../core/utils/useHandleParamNavigation";
import { handleLogout } from "../utils/handleLogout";
import { useHandleSideBarNavItems } from "../utils/useHandleSideBarNavItems";
import { useEndReleaseSession } from "../utils/webAppSession";
import { Footer } from "./Footer";
import { LogoComponent } from "./LogoComponent";
import { SideBarNavItem } from "./SideBarNavItem";

export const SideBar = () => {
  const { sideBarNavItems, currentActiveIndex } = useHandleSideBarNavItems();
  const navigate = useHandleParamNavigation();
  const practiceId = useMainStore(getCurrentPracticeId);
  const logoUrl = useMainStore((state) =>
    getPracticeLogoUrlById(state, practiceId || ""),
  );
  const endReleaseSession = useEndReleaseSession();
  const handleLogoClick = () => {
    // A release session (PF-6133) ends on its own end screen. The marker is read before the logout clears it.
    if (getIsReleaseSession(useMainStore.getState())) {
      void endReleaseSession({ ended: true });
      return;
    }
    void handleLogout();
  };
  return (
    <SideBarContainer>
      {logoUrl && (
        <LogoContainer onClick={handleLogoClick}>
          <LogoComponent />
        </LogoContainer>
      )}
      <NavItemsContainer>
        {sideBarNavItems.map((item) => {
          return (
            <Fragment key={item.index + item.screen}>
              <SideBarNavItem
                {...item}
                active={item.index <= currentActiveIndex}
                onClick={
                  item.index < currentActiveIndex
                    ? () => navigate(`/appointment/${item.screen}`)
                    : undefined
                }
              />
              {item.index < sideBarNavItems.length - 1 && (
                <TrailingLineContainer>
                  <TrailingLine $isActive={item.index < currentActiveIndex} />
                </TrailingLineContainer>
              )}
            </Fragment>
          );
        })}
      </NavItemsContainer>
      <StyledFooter />
    </SideBarContainer>
  );
};

const StyledFooter = styled(Footer)`
  position: absolute;
  bottom: 0;
`;

const TrailingLineContainer = styled.div`
  width: 100%;
  height: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-left: 22px; // 10 + 24/2
  padding-top: 2px;
  padding-bottom: 2px;
`;

const TrailingLine = styled.div<{ $isActive: boolean }>`
  width: 1px;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  opacity: ${(props) => (props.$isActive ? 1 : 0.6)};
`;

const NavItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const SideBarContainer = styled.div`
  width: 30vw;
  background-color: ${({ theme }) => theme.colors.dark};
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
`;

const LogoContainer = styled(CustomButton)`
  position: absolute;
  top: 0;
  background-color: ${({ theme }) => theme.colors.white};
  width: min(50%, 260px);
  display: flex;
  justify-content: center;
  padding-top: clamp(24px, 5vw, 60px);
  padding-bottom: clamp(14px, 2.5vw, 30px);
  border-radius: 0 0 15px 15px;
`;
